<template>
  <div>
    <nav class="woocommerce-breadcrumb" itemprop="breadcrumb">
      <a href="/dashboard">Dashboard</a> / Inventory / <a href="/inventory/contacts">My Contacts</a> /
      <a href="/inventory/contacts/imports">Imports</a> / <span> Report </span>
    </nav>
    <div class="container-fluid">
      <div class="jumbotron" style="padding-bottom: 0;">
        <h1>Import Report</h1>
        <div class="well">
          <p>
            The details for the import started at {{ dateLarge(this.import.finished_at, timezone) }} are below. To
            return to view all imports, <a href="../">click here</a>
          </p>
        </div>
      </div>
      <div class="well manage-stats col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12" style="text-align: left;font-size: 18px; padding-bottom: 20px;">
              <div>
                <b>Type:</b> &nbsp; <span class="type">{{ this.import.type }}</span>
              </div>

              <div v-if="this.import.campaign">
                <b>Campaign:</b> &nbsp; <span>{{ this.import.campaign }}</span>
              </div>
              <div v-if="this.import.audience">
                <b>Audience:</b> &nbsp; <span>{{ this.import.audience }}</span>
              </div>

              <div>
                <b>Status:</b> &nbsp; <span class="status">{{ this.import.status }}</span>
              </div>

              <div class="mt-3"><b>Started:</b> &nbsp; {{ dateLarge(this.import.initiated_at, timezone) }}</div>
              <div v-if="this.import.finished_at">
                <b>Finished:</b> &nbsp; {{ dateLarge(this.import.finished_at, timezone) }}
              </div>

              <div v-if="this.import.processed" class="mt-3"><b>Processed:</b> &nbsp; {{ this.import.processed }}</div>

              <div v-if="this.import.rejected"><b>Rejected:</b> &nbsp; {{ this.import.rejected }}</div>

              <div v-if="this.import.received"><b>Received:</b> &nbsp; {{ this.import.received }}</div>

              <div v-if="this.import.joined"><b>Joined:</b> &nbsp; {{ this.import.joined }}</div>

              <div v-if="this.import.error" class="mt-3">
                <b>Error:</b>
                <div class="panel panel-default">
                  <div class="panel-body">
                    {{ this.import.error }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactImportsTable from '../components/contact/import/ContactImportsTable';
import dateFormatter from '../mixins/dateFormatter';

export default {
  name: 'contact-import-detail-page',
  components: {ContactImportsTable},
  mixins: [dateFormatter],
  props: {
    import: {
      type: Object,
      required: true,
    },
    timezone: {
      type: String,
      required: true,
    },
    vesselId: {
      type: Number,
      required: true,
    },
  },
};
</script>
